<ng-container *transloco="let t">
  <section>
    <div class="grid grid-cols-2 gap-6">
      <div>
        <h6 class="mb-8">{{ t('settings.preferences.notifications.tourConfirmation.title') }}</h6>
        <div>
          <form nz-form [formGroup]="notificationForm">
            <label
              class="mb-2"
              nz-checkbox
              formControlName="isTourConfirmationEnabled">
              {{ t('settings.preferences.notifications.tourConfirmation.enableEmailNotification') }}
            </label>
            <div
              *ngIf="
                this.notificationForm.controls['isTourConfirmationEnabled'].value
              ">
              <nz-form-item class="mb-1">
                <nz-form-label class="w-20 mr-2" nzFor="sendEmailTo">
                  {{ t('settings.preferences.notifications.tourConfirmation.recipient') }}
                </nz-form-label>
                <nz-form-control [nzErrorTip]="emailToCheck">
                  <nz-select
                    nzMode="tags"
                    [nzPlaceHolder]="t('settings.preferences.notifications.tourConfirmation.recipientPlaceholder')"
                    formControlName="emails"
                    nzPlacement="topLeft">
                  </nz-select>
                </nz-form-control>
                <ng-template class="m-0" #emailToCheck>
                  <span *ngIf="formErrors.emails.required">
                    {{ t('settings.preferences.notifications.errors.emailRequired') }}
                  </span>
                  <span *ngIf="formErrors.emails.email"> {{ t('settings.preferences.notifications.errors.emailInvalid') }} </span>
                </ng-template>
              </nz-form-item>
              <label class="mt-3" nz-checkbox formControlName="isAttachItinerary">
                {{ t('settings.preferences.notifications.tourConfirmation.attachItineraryPdf') }}
              </label>
            </div>
          </form>
          <div class="flex justify-end">
            <button nz-button nzType="primary" (click)="updateBrand('tour confirmation')">
              {{ t('settings.common.update') }}
            </button>
          </div>
          <div class="mb-3" *ngIf="msg === 'tour confirmation'">
            <nz-alert
              *ngIf="actionMessage.display && actionMessage.isAdd"
              class="mt-2"
              [nzType]="actionMessage.type"
              [nzMessage]="actionMessage.message"
              nzShowIcon
              nzCloseable></nz-alert>
          </div>
        </div>
      </div>
      <div>
      </div>
      <div class="mt-7">
        <div>
          <h6 class="mb-8">{{ t('settings.preferences.notifications.itineraryView.title') }}</h6>
          <div class="flex flex-row items-center justify-between gap-5">
            <form nz-form [formGroup]="itineraryViewNotificationForm">
              <div>
                <label nz-checkbox formControlName="toNotifySuperAdmin">
                  {{ t('settings.preferences.notifications.itineraryView.notifySuperAdmin') }}
                </label>
                <label  nz-checkbox formControlName="toNotifyCreator">
                  {{ t('settings.preferences.notifications.itineraryView.notifyUser') }}
                </label>
              </div>
            </form>
            <div>
              <button nz-button nzType="primary" (click)="updateBrand('itinerary view')">
                {{ t('settings.common.update') }}
              </button>
            </div>
          </div>
          <div class="mb-3" *ngIf="msg === 'itinerary view'">
            <nz-alert
              *ngIf="actionMessage.display && actionMessage.isAdd"
              class="mt-2"
              [nzType]="actionMessage.type"
              [nzMessage]="actionMessage.message"
              nzShowIcon
              nzCloseable></nz-alert>
          </div>
        </div>
      </div>
      <div>
      </div>
      <div class="mt-7">
        <h6 class="mb-8">{{ t('settings.preferences.notifications.b2bItineraryExpirationLink.title') }}</h6>
        <div class="flex flex-row items-center justify-between gap-5">
          <form nz-form [formGroup]="notificationForm">
            <div class="flex gap-8">
              <label
                nz-checkbox
                [nzChecked]="notificationForm.get('isB2bItineraryLinkEnabled')?.value === true"
                (nzCheckedChange)="notificationForm.get('isB2bItineraryLinkEnabled')?.setValue(true)">
                {{ t('settings.preferences.notifications.b2bItineraryExpirationLink.enable') }}
              </label>
              <label
                nz-checkbox
                [nzChecked]="notificationForm.get('isB2bItineraryLinkEnabled')?.value === false"
                (nzCheckedChange)="notificationForm.get('isB2bItineraryLinkEnabled')?.setValue(false)">
                {{ t('settings.preferences.notifications.b2bItineraryExpirationLink.disable') }}
              </label>
            </div>
          </form>
          <div>
            <button nz-button nzType="primary" (click)="updateBrand('b2b itinerary link')">
              {{ t('settings.common.update') }}
            </button>
          </div>
        </div>
        <div class="mb-3" *ngIf="msg === 'b2b itinerary link'">
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>
      </div>
    </div>
  </section>
</ng-container>
